import {
  USER_SURVEY_REQUEST,
  USER_SURVEY_SUCCESS,
  USER_SURVEY_FAIL,
  USER_SURVEY_CLEAR_ERRORS,
  USER_SURVEY_ANS_REQUEST,
  USER_SURVEY_ANS_SUCCESS,
  USER_SURVEY_ANS_FAIL,
  USER_SURVEY_ANS_CLEAR_ERRORS,
  USER_SURVEY_COMP_REQUEST,
  USER_SURVEY_COMP_SUCCESS,
  USER_SURVEY_COMP_FAIL,
  USER_SURVEY_COMP_CLEAR_ERRORS,
} from "../Constants/user_surveys_constants";

export const user_surveys_reducer = (
  state = {
    user_surveys: [],
  },
  action
) => {
  switch (action.type) {
    case USER_SURVEY_REQUEST:
      return {
        user_surveys_loading: true,
        user_surveys: [],
      };
    case USER_SURVEY_SUCCESS:
      return {
        user_surveys_loading: false,
        user_surveys: action.payload,
      };
    case USER_SURVEY_FAIL:
      return {
        user_surveys_loading: false,
        user_surveys: null,
        user_surveys_error: action.payload,
      };
    case USER_SURVEY_CLEAR_ERRORS:
      return {
        ...state,
        user_surveys_error: null,
      };
    default:
      return state;
  }
};

export const user_surveys_ans_reducer = (
  state = {
    user_surveys_ans: [],
  },
  action
) => {
  switch (action.type) {
    case USER_SURVEY_ANS_REQUEST:
      return {
        user_surveys_ans_loading: true,
        user_surveys_ans: [],
      };
    case USER_SURVEY_ANS_SUCCESS:
      console.log(action.payload);
      return {
        user_surveys_ans_loading: false,
        user_surveys_ans: action.payload,
      };
    case USER_SURVEY_ANS_FAIL:
      return {
        user_surveys_ans_loading: false,
        user_surveys_ans: null,
        user_surveys_ans_error: action.payload,
      };
    case USER_SURVEY_ANS_CLEAR_ERRORS:
      return {
        ...state,
        user_surveys_ans_error: null,
      };
    default:
      return state;
  }
};

export const user_surveys_comp_reducer = (
  state = {
    user_surveys_comp: [],
  },
  action
) => {
  switch (action.type) {
    case USER_SURVEY_COMP_REQUEST:
      return {
        user_surveys_comp_loading: true,
        user_surveys_comp: [],
      };
    case USER_SURVEY_COMP_SUCCESS:
      return {
        user_surveys_comp_loading: false,
        user_surveys_comp: action.payload,
      };
    case USER_SURVEY_COMP_FAIL:
      return {
        user_surveys_comp_loading: false,
        user_surveys_comp: null,
        user_surveys_comp_error: action.payload,
      };
    case USER_SURVEY_COMP_CLEAR_ERRORS:
      return {
        ...state,
        user_surveys_comp_error: null,
      };
    default:
      return state;
  }
};
